'use client';

import { useCart, useUserSession, useLoyaltyContext } from '@libs/common-next';

export function useAccountDropdown() {
    const { memberPoints } = useLoyaltyContext();
    const { storageUserSession, ocapi, userData } = useUserSession();
    const { cart } = useCart();
    const firstName = (userData?.profile?.firstName ?? memberPoints?.firstName ?? '').trim();

    const loyaltyPoints = memberPoints?.availablePoints ?? storageUserSession?.loyaltyPoints ?? 0;

    const isLoggedIn = Boolean(memberPoints?.firstName);
    const isLoadingUserProfile = isLoggedIn && !userData?.profile?.firstName;
    const isLoadingGuest = ocapi.isLoading && !isLoggedIn;
    const isLoading = isLoadingUserProfile || isLoadingGuest;
    const currentMemberLevel = memberPoints?.currentTierLevel ?? 'member';
    const availableDollars = memberPoints?.availableDollars ?? 0;
    const qty = cart?.summary?.itemCount ?? undefined;

    return {
        isLoading,
        firstName,
        loyaltyPoints,
        currentMemberLevel,
        availableDollars,
        qty,
    };
}
